import React, { useState } from "react";
import Icon from "../../../components/AppIcon";

const skillsData = {
  categories: [
    {
      id: "frontend",
      label: "Frontend",
      icon: "Monitor",
      skills: [
        { name: "React / React 18", level: 95 },
        { name: "TypeScript", level: 88 },
        { name: "JavaScript (ES2023)", level: 92 },
        { name: "HTML5 & CSS3", level: 97 },
        { name: "Tailwind CSS", level: 90 },
        { name: "Firebase", level: 82 },
      ],
    },
    {
      id: "frameworks",
      label: "Frameworks & Libraries",
      icon: "Layers",
      skills: [
        { name: "Redux Toolkit", level: 85 },
        { name: "React Query", level: 80 },
        { name: "Framer Motion", level: 78 },
        { name: "Storybook", level: 75 },
        { name: "Angular ClI", level: 80 },
        { name: "Vite / Webpack", level: 82 },
      ],
    },
    {
      id: "tools",
      label: "Tools & Workflow",
      icon: "Wrench",
      skills: [
        { name: "Git & GitHub", level: 92 },
        { name: "Figma", level: 85 },
        { name: "Docker (basics)", level: 65 },
        { name: "CI/CD (GitHub Actions)", level: 72 },
        { name: "REST APIs ", level: 88 },
        { name: "PostMan", level: 70 },
      ],
    },
  ],
  techBadges: [
    "React", "TypeScript", "JavaScript", "Angular", "Tailwind CSS",
    "Redux",  "Json Server", "Git", "Figma", "GitHub", "Vite",
    "HTML5", "CSS3", "Framer Motion", "REST APIs" ,"FireBase","TeamWork","LeaderShip",'Problem Solving',"Vercel","Netlify",
  ],
};

function SkillBar({ name, level }) {
  return (
    <div className="mb-4">
      <div className="flex justify-between items-center mb-1.5">
        <span className="text-sm font-medium" style={{ color: "var(--color-foreground)", fontFamily: "var(--font-caption)" }}>
          {name}
        </span>
        <span className="text-xs font-semibold" style={{ color: "var(--color-primary)", fontFamily: "var(--font-data)" }}>
          {level}%
        </span>
      </div>
      <div className="h-1.5 rounded-full overflow-hidden" style={{ background: "var(--color-border)" }}>
        <div
          className="h-full rounded-full transition-all duration-700"
          style={{ width: `${level}%`, background: "linear-gradient(90deg, var(--color-primary), var(--color-accent))" }}
        />
      </div>
    </div>
  );
}

export default function SkillsSection() {
  const [activeCategory, setActiveCategory] = useState("frontend");
  const active = skillsData?.categories?.find((c) => c?.id === activeCategory);

  return (
    <div className="py-16 md:py-20" style={{ background: "var(--color-background)" }}>
      <div className="max-w-6xl mx-auto px-4 md:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-12">
          <p className="text-xs font-semibold tracking-widest uppercase mb-2" style={{ color: "var(--color-primary)", fontFamily: "var(--font-caption)" }}>
            What I Work With
          </p>
          <h2 className="text-3xl md:text-4xl font-bold" style={{ fontFamily: "var(--font-heading)", color: "var(--color-foreground)" }}>
            Technical Skills
          </h2>
        </div>

        {/* Category Tabs */}
        <div className="flex gap-2 mb-8 overflow-x-auto pb-2">
          {skillsData?.categories?.map((cat) => (
            <button
              key={cat?.id}
              onClick={() => setActiveCategory(cat?.id)}
              className="flex items-center gap-2 px-4 py-2.5 rounded-lg text-sm font-medium whitespace-nowrap flex-shrink-0 border transition-all duration-200"
              style={{
                fontFamily: "var(--font-heading)",
                background: activeCategory === cat?.id ? "var(--color-primary)" : "var(--color-card)",
                color: activeCategory === cat?.id ? "var(--color-primary-foreground)" : "var(--color-muted-foreground)",
                borderColor: activeCategory === cat?.id ? "var(--color-primary)" : "var(--color-border)",
                boxShadow: activeCategory === cat?.id ? "0 0 16px rgba(124,106,247,0.3)" : "none",
              }}
            >
              <Icon name={cat?.icon} size={16} color={activeCategory === cat?.id ? "#fff" : "var(--color-muted-foreground)"} />
              {cat?.label}
            </button>
          ))}
        </div>

        {/* Skill Bars */}
        <div
          className="p-6 md:p-8 rounded-xl border mb-10"
          style={{ background: "var(--color-card)", borderColor: "var(--color-border)" }}
        >
          <div className="grid grid-cols-1 md:grid-cols-2 gap-x-10">
            {active?.skills?.map((skill) => (
              <SkillBar key={skill?.name} name={skill?.name} level={skill?.level} />
            ))}
          </div>
        </div>

        {/* Tech Badges */}
        <div>
          <p className="text-xs font-semibold uppercase tracking-wider mb-4 text-center" style={{ color: "var(--color-muted-foreground)", fontFamily: "var(--font-caption)" }}>
            Technologies I've Worked With
          </p>
          <div className="flex flex-wrap gap-2 justify-center">
            {skillsData?.techBadges?.map((tech) => (
              <span
                key={tech}
                className="px-3 py-1.5 text-xs font-semibold rounded-lg border transition-all duration-200 hover:border-primary cursor-default"
                style={{
                  fontFamily: "var(--font-caption)",
                  background: "var(--color-card)",
                  color: "var(--color-foreground)",
                  borderColor: "var(--color-border)",
                }}
              >
                {tech}
              </span>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}